import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useAuthContext } from '@/auth/useAuthContext';
import { useAbility } from '@/providers/';
import {
  FiltersToFormData,
  getAccessToken,
  triggerDownload,
  renderMultiAvatars,
  createDataTableOptions,
  createDataTableConfig,
  decodeHtmlEntities,
  FormatFileSize
} from '@/utils'
import { KeenIcon, DefaultTooltip, LazyFormikSelect } from '@/components';
import { cn } from '@/lib/utils';
import { SelectInput, DateInput, ColumnToggleDropdown, FilterContainer, } from '@/components/TableFilter'
import { toast } from 'sonner';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
// Data tbale
import DataTable from 'datatables.net-react';
import 'datatables.net-select-dt';
import 'datatables.net-responsive-dt';
import { goTo403 } from "@/utils/Navigation";
import { useNavigate } from 'react-router';
import { createRoot } from 'react-dom/client';
import { Can } from '@casl/react';
import { Button } from "@/components/ui/button";
import uploadDocumentService from '@/services/document/uploadDocumentService';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useDropzone } from 'react-dropzone';
// Services
import documentTemplateService from '@/services/document/document-template/documentTemplateService';
import userService from '@/services/setting/userService'
import { useConfirmationModal } from '@/hooks';
import { ConfirmationModal } from '@/components/modal';
import { useUserOptions } from '@/hooks'
import { Container } from '@/components/container';
import bulkDeleteService from '@/services/bulk-delete/bulkDeleteService';
import useDataTableBulkDelete from '@/hooks/useDataTableBulkDelete';
import { BulkDeleteActions } from '@/components/BulkDeleteActions';

const DocumentTemplate = () => {
  const { logout } = useAuthContext();

  const [filterData, setFilterData] = useState({
    from_date: null,
    to_date: null,
    date_range: null,
    status: null,
    contact_id: null,
    matter_id: null,
  });
  const { isOpen, actionId, openModal, closeModal } = useConfirmationModal();
  const API_URL = import.meta.env.VITE_APP_BASE_URL;
  const token = getAccessToken();
  const [showFilter, setShowFilter] = useState(false);
  const { ability } = useAbility();
  // Refs
  const tableRef = useRef(null);
  const formikRef = useRef(null);
  const filterRef = useRef(filterData);
  const Navigate = useNavigate()
  const [showDocumentPreviewModal, setShowDocumentPreviewModal] = useState(false)
  const [documentPreviewRes, setDocumentPreviewRes] = useState(null)
  const [previewLoading, setPreviewLoading] = useState(false)
  const [openDocumentModal, setOpenDocumentModal] = useState(false)
  const [uploadedFiles, setUploadedFiles] = useState([]); // valid only
  const [rejectedFiles, setRejectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [mode, setMode] = useState('create');
  const [itemId, setItemId] = useState(null)
  const [itemdData, setItemdData] = useState(null)
  const [initialValues, setInitialValues] = useState({
    file_name: '',
    file: null,
    description: '',
    visibility: 'public',
    existing_file: null,
  })
  const [allowMultiUpload, setAllowMultiUpload] = useState(false)
  const canEditDocument = ability.can('handle', 'document-template');
  const canDeleteDocument = ability.can('delete', 'document-template');
  const loadUserOptions = useUserOptions({ defaultPageSize: 20 });
  const columnOrderStorageKey = typeof window !== 'undefined'
    ? `column-toggle-order:${window.location.pathname}`
    : null;
  const {
    selectedRows,
    allSelected,
    bulkDeleteLoading,
    bulkDeleteOpen,
    openBulkDelete,
    closeBulkDelete,
    confirmBulkDelete,
    toggleSelectPage,
  } = useDataTableBulkDelete({
    tableRef,
    model: 'DocumentTemplate',
    deleteFn: bulkDeleteService.bulkDelete,
    onSuccess: () => {
      refresh();
      toast.success('Documents Deleted', {
        description: 'Selected documents deleted successfully and moved to the recycle bin.',
      });
    },
    onError: (error) => {
      console.error('Error', error);
      toast.error('Failed to delete selected documents.', {
        description: 'An error occurred while deleting documents. Please try again.',
      });
    },
  });

  const isViewMode = mode === 'edit';
  const MAX_FILE_SIZE = 50 * 1024 * 1024; // 100 MB per file
  const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 100 MB total

  const ALLOWED_MIME = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/vnd.ms-excel',                                                // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // .xlsx
  ];

  const ALLOWED_EXT = ['.pdf', '.doc', '.docx', '.xls', '.xlsx'];

  const acceptMap = {
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  };

  const columns = useMemo(() => ([
    // {
    //   data: null,
    //   defaultContent: '',
    //   className: 'select-checkbox',
    //   id: 'document-template-checkbox-select',
    //   orderable: false,
    //   name: 'checkbox',
    // },
    // {
    //   title: 'S#',
    //   data: null,
    //   name: 'serial',
    //   selector: (row, index) => index + 1,
    //   className: 'table_serial_num',
    //   center: true,
    //orderable: true,se,
    //   render: function (data, type, row, meta) {
    //     return meta.row + 1;
    //   }
    // },
    {
      data: 'file_name',
      title: 'Document Name',
      name: 'file_name',
      render: function (data, type, row) {
        return `<div class="w-[180px] whitespace-pre-wrap truncate" id="document-name-cell-${row.id}"></div>`;
      }
    },
    {
      data: 'description',
      title: 'Description',
      name: 'description',
      render: function (value, data, row) {
        return `<div class="w-[180px] !whitespace-nowrap truncate line-clamp-2" id="document-desc-cell-${row.id}"></div>`;
      }
    },
    {
      data: 'visibility',
      name: 'visibility',
      title: 'Visible As',
      render: function (value) {
        const badgeClass = value === 'public' ? 'badge-success' : 'badge-danger';
        return `<span class="capitalize badge badge-pill badge-outline ${badgeClass} gap-1 items-center">
              <span class="badge badge-dot size-1.5 ${badgeClass}"></span>
              ${value === 'public' ? 'Public Document' : 'Private Document'}
            </span>`
      }
    },
    {
      title: 'Created By',
      name: 'created_by',
      data: 'created_by',
      orderable: true,
      searchable: false,
      render: function (data, type, row) {
        return `<div id="created-by-${row.id}"></div>`;
      }
    },
    {
      data: 'created_at',
      name: 'created_at',
      title: 'Created At',
      orderable: true
    },
    {
      title: 'Actions',
      name: 'actions',
      data: null,
      orderable: false,
      searchable: false,
      render: function (data, type, row) {
        return `<div id="action-cell-${row.id}"></div>`;
      }
    }
  ]), []);

  const defaultVisibleColumns = [
    'checkbox',
    'file_name',
    'description',
    'visibility',
    'created_by',
    'created_at',
    'actions',
  ];

  const ajaxConfig = createDataTableConfig('/documents/document-templates/list', filterRef, token, logout);
  const headerCheckboxId = 'document-template-select-all';

  const syncHeaderCheckbox = useCallback(() => {
    const table = tableRef?.current?.dt?.();
    if (!table) return;
    const headerCheckbox = document.getElementById(headerCheckboxId);
    if (!headerCheckbox) return;
    const totalOnPage = table.rows({ page: 'current' }).count();
    const selectedOnPage = table.rows({ selected: true, page: 'current' }).count();
    headerCheckbox.checked = totalOnPage > 0 && totalOnPage === selectedOnPage;
    headerCheckbox.indeterminate = selectedOnPage > 0 && selectedOnPage < totalOnPage;
  }, []);

  const setupHeaderCheckbox = useCallback((api) => {
    const headerCell = api.column('checkbox:name').header();
    if (!headerCell) return;
    headerCell.innerHTML = `
      <label class="inline-flex items-center cursor-pointer">
        <input id="${headerCheckboxId}" type="checkbox" class="checkbox checkbox-sm cursor-pointer form-checkbox" />
      </label>
    `;
    const headerCheckbox = headerCell.querySelector(`#${headerCheckboxId}`);
    if (headerCheckbox) {
      headerCheckbox.addEventListener('change', (event) => {
        event.stopPropagation();
        const table = tableRef?.current?.dt?.();
        if (!table) return;
        if (event.target.checked) {
          table.rows({ page: 'current' }).select();
        } else {
          table.rows({ page: 'current' }).deselect();
        }
        syncHeaderCheckbox();
      });
    }
  }, [syncHeaderCheckbox]);

  // const ajaxConfig = {
  //   method: 'POST',
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  //   url: `${API_URL}/document-templates/list`,
  //   xhrFields: {
  //     withCredentials: true
  //   },
  //   data(dt) {
  //     const activeFilters = filterRef.current;

  //     FiltersToFormData(activeFilters, dt);

  //     return dt;
  //   },
  //   error: function (xhr, error, thrown) {
  //     if (xhr.status === 401) {
  //       logout();
  //     } else if (xhr.status === 403) {
  //       goTo403()
  //     }
  //   }
  // }

  const options = createDataTableOptions({
    order: [[4, "desc"]],
    select: {
      style: 'multi',
      selector: 'td.select-checkbox'
    },
    initComplete: function () {
      const api = this.api();
      setupHeaderCheckbox(api);
      api.on('select deselect draw', syncHeaderCheckbox);
      api.on('page', () => {
        api.rows().deselect();
      });
      api.columns().every(function () {
        const col = this;
        const name = col.settings()[0].aoColumns[col.index()].name;
        if (name && !defaultVisibleColumns.includes(name)) {
          col.visible(false);
        }
      });
    },
    drawCallback: function () {
      const api = this.api();
      const rows = api.rows({ page: 'current' }).data();
      syncHeaderCheckbox();

      rows.each((row) => {
        const actionContainer = document.getElementById(`action-cell-${row.id}`);
        if (actionContainer) {
          if (!actionContainer._reactRoot) {
            actionContainer._reactRoot = createRoot(actionContainer);
          }
          actionContainer._reactRoot.render(renderCustomActions(row));
        }
        const documentContainer = document.getElementById(`document-name-cell-${row.id}`);
        if (documentContainer) {
          if (!documentContainer._reactRoot) {
            documentContainer._reactRoot = createRoot(documentContainer);
          }
          documentContainer._reactRoot.render(renderDocumentPreview(row));
        }
        const documentDescContainer = document.getElementById(`document-desc-cell-${row.id}`);
        if (documentDescContainer) {
          if (!documentDescContainer._reactRoot) {
            documentDescContainer._reactRoot = createRoot(documentDescContainer);
          }
          documentDescContainer._reactRoot.render(renderDocumentDesc(row));
        }
        const createdByContainer = document.getElementById(`created-by-${row.id}`);
        if (createdByContainer) {
          if (!createdByContainer._reactRoot) {
            createdByContainer._reactRoot = createRoot(createdByContainer);
          }
          createdByContainer._reactRoot.render(renderMultiAvatars(row.created_by));
        }
      })
    },
  });

  const renderDocumentPreview = (row) => {
    const { token, file_name, status } = row;
    return (
      <span>
        <DefaultTooltip title={file_name} placement="top">
          {file_name}
        </DefaultTooltip>
      </span>
    )
  }

  const renderDocumentDesc = (row) => {
    const { description } = row;
    return (
      <DefaultTooltip title={description} placement="left">
        {description}
      </DefaultTooltip>
    )
  }

  const handleToggleDocPreview = async (id, row) => {

    setPreviewLoading(true);
    setShowDocumentPreviewModal(true);

    try {
      const blob = row.status === 'pending' ? await eSignatureService.downloadSignDocument(id, null) : await eSignatureService.downloadSignDocument(id);

      console.log("blob -->", blob, blob.type);

      // Convert blob to previewable URL
      const objectUrl = URL.createObjectURL(blob);

      setDocumentPreviewRes({
        url: objectUrl,
        type: blob.type,        // "image/png", "application/pdf", etc.
      });


    } catch (error) {
      console.error("Error", error);
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const handleFilterChange = (key, val) => {
    setFilterData((prev) => {
      const updated = { ...prev, [key]: val };
      filterRef.current = updated;
      //console.log('updated',updated)
      return updated;
    });
  };

  const refresh = () => {
    const table = tableRef.current.dt();
    table.ajax.reload();
  };

  const resetFilters = () => {
    const cleared = {
      status: null,
      from_date: null,
      to_date: null,
      date_range: null,
    };

    setFilterData(cleared);
    filterRef.current = cleared;
    refresh()
  };

  useEffect(() => {
    filterRef.current = filterData;
  }, [filterData]);

  const renderCustomActions = (row) => {
    console.log('row', row);

    const { token, status, document_name, id } = row;

    return (

      <DropdownMenu>
        {(canEditDocument || canDeleteDocument) && (
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="text-gray-600">
              <KeenIcon icon="dots-vertical" className="text-[18px]" />
            </Button>
          </DropdownMenuTrigger>
        )}

        <DropdownMenuContent align="end" className="w-52">
          <Can I="handle" a="document-template" ability={ability}>
            <DropdownMenuItem onClick={() => handleOpenModal(row)}>
              <KeenIcon icon="notepad-edit" className="mr-0.5 h-4 w-4 cursor-pointer" /> Edit Document
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => handleDownload(row)}>
              <KeenIcon icon="exit-up" className="mr-0.5 h-4 w-4 cursor-pointer" /> Download Document
            </DropdownMenuItem>
          </Can>
          <Can I="delete" a="document-template" ability={ability}>
            <DropdownMenuItem onClick={() => openModal(id)} className="text-red-600 cusror-pointer">
              <KeenIcon icon="trash" className="mr-0.5 h-4 w-4" /> Delete
            </DropdownMenuItem>
          </Can>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  };

  const handleDownload = async (row) => {
    const { id, file_name, file_path } = row;
    const fileExtension = file_path.split('.').pop();
    // return
    try {
      const blob = await documentTemplateService.downloadDocument(id);
      triggerDownload(blob, `${file_name}.${fileExtension}`);
      toast.success('Document downloaded!');
    } catch (error) {
      console.error('Error', error);
      toast.error('Oops! Something went wrong.', {
        description:
          'An error occurred while downloading document. Please try again in a moment.',
      });
    }
  };

  const validationSchema = Yup.object().shape({
    // file_name: Yup.string().max(255, 'Document name cannot exceed 255 characters').required('Document name is required'),
    file_name: Yup.string()
      .max(255, 'Document name cannot exceed 255 characters')
      .when('$allowMultiUpload', {
        is: false,
        then: (s) => s.required('Document name is required'),
        otherwise: (s) => s.notRequired(),
      }),
    // file: Yup.mixed().required('Document is required'),
    description: Yup.string().nullable().max(1000, 'Description cannot exceed 1000 characters'),
    visibility: Yup.string().required('Visibility is required'),
  })

  const onDrop = (acceptedFiles, fileRejections) => {
    const valid = [];
    const invalid = []; // { file, reasons: [] }

    // Re-check accepted for safety (type/size)
    acceptedFiles?.forEach((file) => {
      const ext = `.${(file.name?.split('.').pop() || '').toLowerCase()}`;
      const isValidType = ALLOWED_MIME.includes(file.type) || ALLOWED_EXT.includes(ext);
      const isValidSize = file.size <= MAX_FILE_SIZE;

      if (isValidType && isValidSize) {
        valid.push(file);
      } else {
        const reasons = [];
        if (!isValidType) reasons.push('Invalid type (allowed: PDF, DOC, DOCX, XLS, XLSX)');
        if (!isValidSize) reasons.push('File too large (max 50MB file)');
        invalid.push({ file, reasons });
      }
    });

    // Fold in true rejections from dropzone (oversize/type)
    (fileRejections || []).forEach(({ file, errors }) => {
      const reasons = (errors || []).map(e => {
        if (e.code === 'file-invalid-type') return 'Invalid type (allowed: PDF, DOC, DOCX, XLS, XLSX)';
        if (e.code === 'file-too-large') return 'File too large (max 50MB file)';
        return e.message || 'Rejected';
      });
      invalid.push({ file, reasons });
    });

    // Merge + dedupe valid, then enforce total size
    const mergedValid = dedupeByNameAndSize([...uploadedFiles, ...valid]);
    if (totalSizeOf(mergedValid) > MAX_TOTAL_SIZE) {
      formikRef?.current?.setFieldError(
        'file',
        'Total upload limit is 50MB. Remove the file or upload within the limit.'
      );
    } else {
      setUploadedFiles(mergedValid);
      formikRef?.current?.setFieldValue('file', mergedValid);
      formikRef?.current?.setFieldError('file', undefined);
    }

    // Merge + dedupe rejected (by name+size, merge reasons)
    const merged = [...rejectedFiles];
    invalid.forEach(item => {
      const idx = merged.findIndex(r => r.file.name === item.file.name && r.file.size === item.file.size);
      if (idx === -1) merged.push(item);
      else merged[idx] = {
        file: merged[idx].file,
        reasons: Array.from(new Set([...(merged[idx].reasons || []), ...(item.reasons || [])]))
      };
    });
    setRejectedFiles(merged);

    if ((invalid?.length || 0) > 0) {
      formikRef?.current?.setFieldError(
        'file',
        'One or more files were rejected. Only PDF, DOC, DOCX, XLS, XLSX under 50MB each are allowed.'
      );
    }
  };

  const dedupeByNameAndSize = (files) => {
    const seen = new Set();
    return files.filter(f => {
      const key = `${f.name}__${f.size}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  const totalSizeOf = (files) => files.reduce((acc, f) => acc + (f?.size || 0), 0);

  const removeFile = (index) => {
    const updated = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updated);
    formikRef?.current?.setFieldValue('file', updated);

    if (totalSizeOf(updated) > MAX_TOTAL_SIZE) {
      formikRef?.current?.setFieldError('file', 'Total upload limit is 50MB. Remove the file or upload within the limit.');
    } else {
      formikRef?.current?.setFieldError('file', undefined);
    }
  };

  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    onDrop,
    noClick: false,
    noKeyboard: true,
    multiple: allowMultiUpload,
    accept: acceptMap,
    maxSize: MAX_FILE_SIZE, // 100MB per file
    onDropRejected: (rejectedFiles) => {
      // Handle rejected files (invalid size/type)
      if (rejectedFiles.length > 0) {
        toast.error('One or more files were rejected. Only PDF, DOC, DOCX, XLS, XLSX under 50MB each are allowed.');
      }
    }
  });

  const handleSubmitDocument = async (values) => {
    const isEdit = mode === 'edit';
    console.log(values)
    const formData = new FormData();
    if (!allowMultiUpload) formData.append('file_name', values.file_name);

    if (!allowMultiUpload) formData.append('description', values.description);
    formData.append('visibility', values.visibility);

    if ((values.file && values.file.length > 0) && !allowMultiUpload) {
      formData.append('file', values.file[0]);
    }
    if (values.file && values.file.length > 0 && allowMultiUpload) {
      values.file.forEach((file, index) => {
        formData.append(`file[]`, file);
      });
    }
    const action = isEdit ? documentTemplateService.updateDocument
      : allowMultiUpload ? documentTemplateService.uploadBulkDocument
        : documentTemplateService.uploadDocument;
    const args = isEdit ? [formData, itemId] : [formData];
    isEdit ? setLoading(true) : setIsLoading(true);
    try {
      const { data, status } = await action(...args);
      if (status) {
        handleModalClose();
        refresh();
        toast.success(`Document ${isEdit ? 'Updated' : 'Created'}.`, {
          description: `${data.file_name} Document ${isEdit ? 'updated' : 'created'} successfully.`,

        })
      }
    } catch (error) {
      console.error('Error', error)
      if (error.message == '422 Unprocessable Entity. Validation failed.') {
        const validationErrors = error.errors
        const formattedErrors = Object.fromEntries(
          Object.entries(validationErrors).map(([key, value]) => [key, value[0]])
        );

        formikRef.current?.setErrors(formattedErrors);
        toast.error('Validation Error.', {
          description: 'Please check your input. Some fields may be invalid.',

        });
      }
    } finally {
      isEdit ? setLoading(false) : setIsLoading(false);
    }
  }

  const handleOpenModal = (row, isMultiple = false) => {
    if (row) {
      setMode('edit');
      console.log(row)
      setItemId(row.id);
      fetchDocument(row.id);
    } else {
      setMode('create');
    }
    setOpenDocumentModal(true);
    setAllowMultiUpload(isMultiple);
  }

  const handleModalClose = () => {
    setInitialValues({
      file_name: '',
      description: '',
      visibility: 'public',
      existing_file: null,
      file: null,
    })
    setItemId(null);
    setItemdData(null);
    setUploadedFiles([]);
    setRejectedFiles([]);
    setMode('create');
    setOpenDocumentModal(false);
    setAllowMultiUpload(false)
  }

  const fetchDocument = async (id) => {
    try {
      const { data, status } = await documentTemplateService.getDocument(id);
      if (status) {
        setItemdData(data);
        setInitialValues({
          file_name: data.file_name,
          description: data.description === null ? '' : data.description,
          visibility: data.visibility,
          existing_file: [
            {
              name: data.file_name,
              size: data.file_size,
              extension: data.file_extension,
              download_url: data.download_url, // Include download URL for preview
            }
          ]
        })
      }
    } catch (error) {
      console.error('Error fetching document', error);
    }
  };

  const handleDelete = async () => {
    closeModal()
    try {
      const { status, data } = await documentTemplateService.deleteDocument(actionId);
      if (status) {
        refresh()
        toast.success('Document Deleted.', {
          description: `Document has been deleted successfully and moved to the recycle bin.`,
        });
      }
    } catch (error) {
      console.error('Error', error)
      if (error.message.includes(`Can't delete:`)) {
        toast.error('Failed to delete.', {
          description: 'The selected item is in use.',
        });
        return
      }
      toast.error('Failed to delete Item.', {
        description: 'An error occurred while deleting Item. Please try again later.',
      });
    }
  }

  return <>
    <Container>
      {/* Filters */}
      <FilterContainer
        show={showFilter}
        onApply={() => refresh()}
        onReset={resetFilters}
      >
        <SelectInput
          label="Visibility"
          value={filterData.visibility}
          onChange={(val) => handleFilterChange('visibility', val)}
          staticOptions={[
            { value: 'public', label: 'Public' },
            { value: 'private', label: 'Private' },
          ]}
          customClass="sm:w-[32%] w-full"
        />

        <SelectInput
          label="Created By"
          type="users"
          value={filterData.created_by}
          onChange={(val) => handleFilterChange('created_by', val)}
          loadOptions={loadUserOptions}
          pageSize={20}
          customClass="sm:w-[32%] w-full"
        />

        <DateInput
          customClass="sm:w-[32%] w-full"
          label="Created At - (From, To)"
          mode="range"
          value={filterData.date_range}
          onChange={(range) => {
            setFilterData(prev => ({
              ...prev,
              from_date: range?.from ?? null,
              to_date: range?.to ?? null,
              date_range: range,
            }));
          }}
        />
      </FilterContainer>

      <div className="min-w-full mb-4 card">
        <div className="card-header">
          <div className='flex items-center gap-1'>
            <ColumnToggleDropdown
              tableRef={tableRef}
              columns={columns}
              defaultVisibleColumns={defaultVisibleColumns}
              storageKey={columnOrderStorageKey}
              pinnedLastColumns={['actions']}
            />
            {/* <h3 className="card-title">Document Templates List</h3> */}
          </div>

          <div className='flex flex-wrap items-center gap-2'>
            <BulkDeleteActions
              canDelete={canDeleteDocument}
              selectedCount={selectedRows.length}
              bulkDeleteLoading={bulkDeleteLoading}
              allSelected={allSelected}
              onOpenConfirm={openBulkDelete}
              onToggleSelectPage={toggleSelectPage}
              confirmOpen={bulkDeleteOpen}
              onCloseConfirm={closeBulkDelete}
              onConfirmDelete={confirmBulkDelete}
              confirmMessage={`You are about to delete ${selectedRows.length} document(s). You can restore it from the Recycle Bin within 30 days.`}
            />
            <button className='text-xs btn btn-sm btn-primary btn-outline' onClick={handleToggleFilter}>
              <KeenIcon icon="filter" className="w-fit btn-icon" />
              {showFilter ? 'Hide Advanced Filters' : 'Advanced Filters'}
            </button>
            <Can I='handle' a='document-template' ability={ability}>
              <button className='text-xs btn btn-sm btn-light' type='button' onClick={() => handleOpenModal()}>
                <KeenIcon icon="plus" className="w-fit btn-icon" />
                Add single
              </button>
              <button className='text-xs btn btn-sm btn-light' type='button' onClick={() => handleOpenModal(null, true)}>
                <KeenIcon icon="some-files" className="w-fit btn-icon" />
                Add Multiple
              </button>
            </Can>
          </div>
        </div>


        <DataTable
          // className='table-with-checkbox'
          id="document-template-table"
          ajax={ajaxConfig}
          columns={columns}
          options={options}
          ref={tableRef}
        />

        {openDocumentModal && (
          <div className='modal-wrapper modal-animate-fade'>
            <div className='modal-animate-scale modal-body w-full max-w-4xl relative'>
              <div className="bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] sticky top-0 z-10">
                <div className="flex justify-between items-center">
                  <h2 className="text-lg font-medium text-gray-900 my-2">
                    {mode === 'create' ? 'Add' : 'Edit'} Document{allowMultiUpload ? 's' : ''}
                  </h2>
                  <button
                    type="button"
                    onClick={() => handleModalClose()}
                    className="text-gray-500 hover:text-gray-700 text-xl"
                  >
                    <KeenIcon icon="cross" />
                  </button>
                </div>
              </div>
              <div className="py-2 min-h-[100px]">
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  validationContext={{ allowMultiUpload }}
                  innerRef={formikRef}
                  onSubmit={(values, formikRef) => {
                    if (!values.file && !values.existing_file) {
                      toast.warning('Please upload a document.');
                      return;
                    }
                    handleSubmitDocument(values, formikRef)
                  }}
                >
                  {({ errors, values, handleChange, handleSubmit, setFieldValue }) => (
                    console.log(errors),
                    <Form noValidate className="space-y-4">
                      {!allowMultiUpload && (
                        <div className='w-full'>
                          <label htmlFor="file_name" className='form-label mb-1'>Document Name <span className='pl-px text-red-500'>*</span></label>
                          <Field name='file_name' className="input" />
                          <div className='flex items-center justify-between mt-1 text-xs text-gray-500'>
                            <span>
                              {(values.file_name?.length || 0)}/{255} characters
                            </span>
                            <ErrorMessage name="file_name" component="div" className="text-red-500 text-xs mt-1" />
                          </div>
                        </div>
                      )}

                      <div className='w-full'>
                        <label htmlFor="visibility" className='form-label mb-1'>Document Visibility</label>
                        <LazyFormikSelect
                          name="visibility"
                          options={[
                            { label: 'Public', value: 'public' },
                            { label: 'private', value: 'private' },
                          ]}
                        />
                        <ErrorMessage name="visibility" component="div" className="text-red-500 text-xs mt-1" />
                      </div>

                      {!allowMultiUpload && (
                        <div className='w-full'>
                          <label htmlFor="description" className='form-label mb-1'>Description</label>
                          <Field as="textarea" rows="4" cols="50" name='description' className="min-h-[120px] input py-3 leading-[1.4em]" />
                          <div className='flex items-center justify-between mt-1 text-xs text-gray-500'>
                            <span>
                              {(values.description?.length || 0)}/{1000} characters
                            </span>
                            <ErrorMessage name="description" component="div" className="text-red-500 text-xs mt-1" />
                          </div>
                        </div>
                      )}

                      {values.existing_file && values.existing_file.length > 0 && (
                        console.log(values.existing_file),
                        <div className="mt-4">
                          <div className="w-full flex items-center justify-between border border-primary p-3 rounded-md bg-primary-light">
                            <div className='flex flex-col'>
                              <p className='text-sm truncate'>{values.existing_file[0].name}</p>
                              <span className="w-fit mt-1.5 truncate badge badge-xs text-[11px] badge-outline badge-primary">Size: {FormatFileSize(values.existing_file[0].size)}</span>
                            </div>
                            <button
                              type="button"
                              onClick={() => {
                                setFieldValue('file', null);
                                setFieldValue('existing_file', null);
                              }}
                              className="ml-4 text-sm text-danger flex items-center gap-0.5"
                            >
                              <KeenIcon icon="trash" />
                              Remove
                            </button>
                          </div>
                        </div>
                      )}


                      {(uploadedFiles.length > 0 || rejectedFiles.length > 0) && (
                        <div className={`flex items-center flex-wrap gap-2 ${allowMultiUpload ? 'max-h-72' : 'max-h-40'} overflow-y-auto mt-2.5`}>
                          {uploadedFiles.map((file, index) => (
                            <div
                              key={`valid-${file.name}-${file.size}-${index}`}
                              className={`${allowMultiUpload ? 'lg:w-[49%] w-full' : 'w-full'} flex lg:flex-nowrap flex-wrap items-center justify-between border border-primary p-3 rounded-md bg-primary-light`}
                            >
                              <div className="flex flex-col">
                                <p className="text-sm truncate max-w-[70%]">{file.name}</p>
                                <span className="w-fit mt-1.5 truncate badge badge-xs text-[11px] badge-outline badge-primary">Size: {FormatFileSize(file.size)}</span>
                              </div>
                              <button
                                type="button"
                                onClick={() => {
                                  removeFile(index)
                                  if (!allowMultiUpload) {
                                    setFieldValue('file', null);
                                    setFieldValue('existing_file', null);
                                  }
                                }}
                                className="ml-4 text-sm text-danger flex items-center gap-0.5"
                              >
                                <KeenIcon icon="trash" />
                                Remove
                              </button>
                            </div>
                          ))}

                          {rejectedFiles.map(({ file, reasons }, index) => (
                            <div
                              key={`rejected-${file.name}-${file.size}-${index}`}
                              className="w-full flex items-center justify-between p-3 rounded-md border border-danger bg-danger-light"
                            >
                              <div className="flex flex-col max-w-[70%]">
                                <p className="text-sm truncate text-danger">{file.name}</p>
                                <span className="w-fit mt-1.5 truncate badge badge-xs text-[11px] badge-outline badge-danger">Size: {FormatFileSize(file.size)}</span>
                                {reasons?.length > 0 && (
                                  <ul className="mt-1 text-[11px] text-danger list-disc pl-4">
                                    {reasons.map((r, i) => <li key={i}>{r}</li>)}
                                  </ul>
                                )}
                              </div>
                              <button
                                type="button"
                                onClick={() => {
                                  setRejectedFiles(prev => prev.filter((_, i) => i !== index))
                                  if (!allowMultiUpload) {
                                    setFieldValue('file', null);
                                    setFieldValue('existing_file', null);
                                  }
                                }}
                                className="ml-4 text-sm underline text-danger"
                              >
                                Remove
                              </button>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className='mt-2'>
                        {(allowMultiUpload || (!values.file && !values.existing_file)) && (
                          console.log('FILES', values.file, values.existing_file),
                          <div {...getRootProps()} className="group hover:border-primary hover:bg-primary-light border-2 border-dashed my-5 p-5 h-[150px] flex items-center justify-center flex-col text-sm rounded-md cursor-pointer transition">
                            <input {...getInputProps()} />
                            <KeenIcon icon="file-up" className="group-hover:text-primary group-hover:scale-110 transition-all text-gray-500 text-3xl mb-2" />
                            <p className="group-hover:text-primary-active">Drag & drop your file here, or click to select</p>
                            <p className="mt-1 text-xs text-gray-400 group-hover:text-gray-600">Max size: 50MB</p>
                            <ErrorMessage name="file" component="div" className="text-red-500 text-xs mt-1" />
                          </div>
                        )}
                        {console.log(rejectedFiles.map(({ file }) => file).length > 0)}
                        <button type="submit" disabled={(loading || isLoading) || rejectedFiles.length > 0} className="btn btn-primary justify-center w-full mt-2">
                          {loading || isLoading ? 'Please wait...' : isViewMode ? 'Update Document' : 'Save Document'}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        )}

        <ConfirmationModal
          show={isOpen}
          onClose={closeModal}
          onConfirm={handleDelete}
          message="Are you sure you want to delete this Document? You can restore it from the Recycle Bin within 30 days."
          title="Are You Sure?"
        />
      </div>
    </Container>
  </>;
};

export { DocumentTemplate };
